export default __webpack_public_path__ + "static/media/doctor-logo.748b0402.png";